import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '2084310',
  title: 'Abertura do módulo',
  video: { platform: 'youtube', videoId: 'ZLveK2-gAjg' },
  article: [
    'Bem-vindo à Introdução Técnica! Nesta aula vamos apresentar a estrutura do curso e os objetivos.',
  ],
};

export default lesson;

